import script from "./ChecklistTemplatesAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./ChecklistTemplatesAdmin.vue?vue&type=script&setup=true&lang=js"

import "./ChecklistTemplatesAdmin.vue?vue&type=style&index=0&id=5eb1d7a0&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb1d7a0"]])

export default __exports__